import { ValidatorRuleType } from "@tCooneyBrothers/Common/Utilities/validate";

export const intialErrorFormState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address1: "",
    zipcode: "",
    city: "",
    address1ShipTo: "",
    cityShipTo: "",
    zipShipTo: "",
    password: "",
    confirmPassword: "",
    // selectCountry: "",
    // selectState: "",
    SelectShipToState: "",
    SelectShipToCountry: "",
    phoneShipTo: "",
};

export const intialErrorFormStateForCreditApp = {
    bankName: "",
    bankAccount: "",
    bankAddress: "",
    bankPhone: "",
    businessRefCompName1: "",
    businessRefName1: "",
    businessRefAddress1: "",
    businessRefPhone1: "",
    businessRefCompName2: "",
    businessRefName2: "",
    businessRefAddress2: "",
    businessRefPhone2: "",
    receivingHours: "",
    IsTerms: "",
    companyOperationalTime: "",
    principalActivity: "",
    apContact: "",
    apContactEmail: "",
    invEmailText: "",
    // Commenting below fields for optional/Conditional validations
    // invFaxNumberText: "",
    // bankFax: "",
    // businessRefFax1: "",
    // businessRefFax2: "",
    // pastBuyerName: "",
    // formerName: "",
    // suitFiledText: "",
    // IsBankruptText: "",
    // upsAccount: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const newCustomerValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        label: "First Name",
    },
    lastName: {
        required: true,
        minLength: 2,
        label: "Last Name",
    },
    email: {
        required: true,
        regex: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
        label: "Email Address",
    },
    phone: {
        required: true,
        maxLength: 12,
        label: "Phone Number",
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
    },
    address1: {
        required: true,
        label: "Address 1",
    },
    zipcode: {
        required: true,
        label: "Zip Code",
    },
    city: {
        required: true,
        label: "City Name",
    },
    address1ShipTo: {
        required: true,
        label: "Shipping Address 1",
    },
    cityShipTo: {
        required: true,
        label: "Shipping City Name",
    },
    zipShipTo: {
        required: true,
        label: "Shipping Zip Code",
    },
    selectCountry: {
        required: true,
        label: "Country",
    },
    selectState: {
        required: true,
        label: "State",
    },
    SelectShipToState: {
        required: true,
        label: "State",
    },
    SelectShipToCountry: {
        required: true,
        label: "Country",
    },
    phoneShipTo: {
        required: true,
        maxLength: 12,
        label: "Phone Number",
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
    },
};

export const newCustomerCreditValidatorConfig: ValidatorConfigType = {
    bankName: {
        required: true,
        minLength: 2,
        label: "Bank Name",
    },
    bankAccount: {
        required: true,
        minLength: 2,
        label: "Bank Account Number",
    },
    bankAddress: {
        required: true,
        minLength: 2,
        label: "Bank Address",
    },
    bankPhone: {
        required: true,
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        label: "Bank Phone Number",
    },
    businessRefCompName1: {
        required: true,
        minLength: 2,
        label: "Businesss Reference Company Name",
    },
    businessRefName1: {
        required: true,
        minLength: 2,
        label: "Businesss Reference Name",
    },
    businessRefAddress1: {
        required: true,
        minLength: 2,
        label: "Businesss Reference Address",
    },
    businessRefPhone1: {
        required: true,
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        label: "Businesss Reference Phone Number",
    },
    businessRefCompName2: {
        required: true,
        minLength: 2,
        label: "Second Businesss Reference Company Name",
    },
    businessRefName2: {
        required: true,
        minLength: 2,
        label: "Second Businesss Reference Name",
    },
    businessRefAddress2: {
        required: true,
        minLength: 2,
        label: "Second Businesss Reference Address",
    },
    businessRefPhone2: {
        required: true,
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        label: "Second Businesss Reference Phone Number",
    },
    receivingHours: {
        required: true,
        label: "Receiving Hours",
    },
    IsTerms: {
        required: true,
        label: "Do you have a UPS account # to be used for shipping?",
        requiredMsg: "Please select: Do you have a UPS account # to be used for shipping?",
    },
    companyOperationalTime: {
        required: true,
        label: "'How long has company operated at the above address?'",
        requiredMsg: "Please enter details for 'How long has company operated at the above address?'",
    },
    principalActivity: {
        required: true,
        label: "'Principal activity of the business?'",
        requiredMsg: "Please enter details for 'Principal activity of the business?'",
    },
    apContact: {
        required: true,
        label: "A/P contact",
    },
    apContactEmail: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "A/P Contact Email",
        requiredMsg: "Please enter email address",
    },
    invEmailText: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "email address for receiving Invoices/Statements",
        requiredMsg: "Please enter email address for receiving Invoices/Statements",
    },
    invFaxNumberText: {
        required: true,
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Invoice Fax Number",
        label: "Invoice Fax Number",
    },
    businessRefFax2: {
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Fax Number",
        label: "Second Businesss Reference Fax Number",
    },
    businessRefFax1: {
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Fax Number",
        label: "Businesss Reference Fax Number",
    },
    bankFax: {
        maxLength: 12,
        maxLengthMsg: "Please Enter Valid Fax Number",
        label: "Bank Fax Number",
    },
    pastBuyerName: {
        required: true,
        label: "Past Buyer Name",
        requiredMsg: "Kindly enter the name.",
    },
    formerName: {
        required: true,
        label: "Former company Name",
        requiredMsg: "Kindly enter the Former company Name.",
    },
    upsAccount: {
        required: true,
        label: "Enter UPS or FedEx account number",
        requiredMsg: "Kindly Enter UPS or FedEx account number.",
    },
    suitFiledText: {
        required: true,
        label: "Please specify",
        requiredMsg: "Please specify.",
    },
    IsBankruptText: {
        required: true,
        label: "Please specify",
        requiredMsg: "Please specify.",
    },
    invFaxText: {
        required: true,
        minLength: 12,
        label: "Fax Number",
        requiredMsg: "Please enter Fax number for receiving Invoices/Statements",
        maxLengthMsg: "Please Enter Valid Fax Number",
    },
};
